import * as actionTypes from '../../constants/actionTypes';

export const setLocalState = (obj) => async dispatch => {
    dispatch({ type: actionTypes.SET_MENU_STATE, data: obj });
};
